import * as React from "react";
import { ExtraIconPro } from "../../../services/product";
import { LeftBottomTag, LeftTopTags, NewRightTopTag } from "./styles";

interface ProductImageTagViewsProps {
	columnNum: number;
	rightTopTag?: ExtraIconPro;
	leftTopTag?: ExtraIconPro;
	leftTopTag2?: ExtraIconPro;
	leftBottomTag?: ExtraIconPro;
	isOnlyShowLeftTopTag?: boolean;
}

export const ProductImageTagViews = (props: ProductImageTagViewsProps) => {
	const { rightTopTag, leftTopTag, leftTopTag2, leftBottomTag, isOnlyShowLeftTopTag } = props;

	const returnLeftTopTag = () => {
		if (leftTopTag && leftTopTag.type === "FLASH_SALE") {
			return leftTopTag;
		} else if (leftTopTag2 && leftTopTag2.type === "FLASH_SALE") {
			return leftTopTag2;
		} else if (leftTopTag && leftTopTag.type === "PROMOTION") {
			return leftTopTag;
		} else if (leftTopTag2 && leftTopTag2.type === "PROMOTION") {
			return leftTopTag2;
		}
	};

	const renderTags = () => {
		if (!isOnlyShowLeftTopTag) {
			return (
				<>
					{rightTopTag?.img && <NewRightTopTag src={rightTopTag?.img} />}
					{(leftTopTag?.img || leftTopTag2?.img) && (
						<LeftTopTags>
							{leftTopTag?.img && <img src={leftTopTag.img} />}
							{leftTopTag2?.img && <img src={leftTopTag2.img} />}
						</LeftTopTags>
					)}
				</>
			);
		} else {
			const showLetTag = returnLeftTopTag() || null;
			return (
				<>
					{showLetTag && showLetTag.img && (
						<LeftTopTags>
							<img src={showLetTag.img} />
						</LeftTopTags>
					)}
				</>
			);
		}
	};

	return (
		<div>
			{renderTags()}
			{leftBottomTag?.img && <LeftBottomTag src={leftBottomTag?.img} />}
		</div>
	);
};
